import React from 'react';
import Slider from "react-slick";
import './style.css';

const ArrowLeft = (props) => (
  <div
    {...props}>
    <div className='d-flex align-items-center justify-content-center w-100 h-100 p-2 mt-3'>
      <i className="fa fa-arrow-left" aria-hidden="true"></i>
    </div>
  </div>
);
const ArrowRight = (props) => (
  <div
    {...props}>
    <div className='d-flex align-items-center justify-content-center w-100 h-100 p-2 mt-3'>
      <i className="fa fa-arrow-right" aria-hidden="true"></i>
    </div>
  </div>
);

const Carousal = (props) => {
  const { settings } = props;
  let config = {
    dots: false,
    infinite: true,
    speed: 100,
    autoplay: true,
    arrows: true,
    prevArrow: <ArrowLeft />,
    nextArrow: <ArrowRight />,
  };

  if (settings) {
    config = {
      ...config,
      ...settings
    }
  }

  return (
    <Slider {...config}>
      {props.children}
    </Slider>
  )
}

export default Carousal;